export default __webpack_public_path__ + "static/media/piggy-bank-with-coins.ab8ef404.svg";